module.exports = __webpack_public_path__ + "img/40.f10baf30.png";